import * as React from "react";

type Props = {
    value: number;
    index: number;
    children: React.ReactNode;
};

export default ({value, index, children}: Props) => {
    return value === index ? (
        <div role="tabpanel" id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`}>
            {children}
        </div>
    ) : null;
};
